import React from 'react'
import classes from './PublicFooter.module.css'
import { Box, Container, Divider, Grid, Text, Flex, Image, ActionIcon, Group } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { IconBrandInstagram, IconBrandLinkedin } from '@tabler/icons-react'
import LajuReaksiLogo from '../../../assets/img/LajuReaksiLight.svg'
import { useViewportSize } from '@mantine/hooks'


const PublicFooter = () => {
  const yearDate = new Date().getFullYear()
  const navigate = useNavigate()
  const { width } = useViewportSize()

  const toRoutePage = (page) => {
    return navigate(page)
  }

  const openLink = (link) => {
    window.open(`${link}`, '_blank')
  }
  return (
    <Box className={classes.defaultSection}>
      <Container fluid className={classes.section}>
        <Divider size="xs" /> 
        <Grid pt={30} pb={20}>
          <Grid.Col span={{ base: 12, lg: 8 }} order={2}>
            <Grid>
              <Grid.Col span={{ base:6, sm: 6, md: 6, lg: 2 }} offset={{ base: 0, sm: 0, md: 0, lg: 6 }}>
                <Text fw="bold">Tentang</Text>
                <Box mt={6}>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/about')}>Tentang Kami</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/blog')}>Blog</Text>
                </Box>
              </Grid.Col>
              <Grid.Col span={{ base:6, sm: 6, md: 6, lg: 2 }}>
                <Text fw="bold">Program</Text>
                <Box mt={6}>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/training')}>Training</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/course')}>Course</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/bootcamp')}>Bootcamp</Text>
                </Box>
              </Grid.Col>
              <Grid.Col span={{ base:6, sm: 6, md: 6, lg: 2 }}>
                <Text fw="bold">Bantuan</Text>
                <Box mt={6}>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/faq')}>FAQ</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/terms-and-condition')}>Syarat & Ketentuan</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/privacy-policy')}>Kebijakan Privasi</Text>
                  <Text className={classes.routeLink} fz={width > 768 ? 13 : 11.5} mb={4} onClick={() => toRoutePage('/validation-certificate')}>Validasi Sertifikat</Text>
                </Box>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col span={{ base: 12, lg: 4 }} order={1} mb={30}>
            <Image mr={24} src={LajuReaksiLogo} w='auto' h={width > 768 ? 65 : 45} />
            <Group spacing={0} position='center' noWrap mt={12}>
              <ActionIcon color="#043056" size="lg" radius="xl" variant="filled" onClick={() => openLink('https://www.linkedin.com/company/katalistalenta?_l=en_US')}>
                <IconBrandLinkedin size="1.4rem" stroke={1.5} />
              </ActionIcon>
              <ActionIcon color="#043056" size="lg" radius="xl" variant="filled"  onClick={() => openLink('https://www.instagram.com/katalistalenta/')}>
                <IconBrandInstagram size="1.4rem" stroke={1.5} />
              </ActionIcon>
            </Group>
          </Grid.Col>
        </Grid>
        <Divider size="xs" />
        <Flex justify="flex-end" align="center" mt="md">
          <Text c='yellow' fz={width > 768 ? 14 : 12} fw='bold'> &copy; { yearDate } PT Katalis Talenta Indonesia</Text>
        </Flex>
      </Container>
    </Box>
  )
}

export default PublicFooter